import {
  RequestAction,
  createEntityActionNames,
  createEntityActions,
  createEntitySelectorsNames,
  createRequestTypes,
} from "store/entities/actions";
import { ActionsUnion, IActionWithPayload, createAction } from "store/helper";
import { IUpdateDefaultMailboxPayload } from "store/views/settings/interfaces";

import {
  IFetchLivechatPropertiesSuccessPayload,
  ILicense,
  IResendVerificationFailurePayload,
  IResendVerificationSuccessPayload,
  ISendForwardingInstructionsFailurePayload,
  ISendForwardingInstructionsPayload,
  ISendForwardingInstructionsSuccessPayload,
  ISetCompanyNameFailurePayload,
  ISetCompanyNamePayload,
  ISetCompanyNameSuccessPayload,
  ISetLicenseFlagPayload,
  ISetPartnerIdPayload,
  ISetPoweredByFooterFailurePayload,
  ISetPoweredByFooterPayload,
  ISetPoweredByFooterSuccessPayload,
  ISetSourceFirstClick,
  ISetUkraineFooterFailurePayload,
  ISetUkraineFooterPayload,
  ISetUkraineFooterSuccessPayload,
  IUpdateDefaultMailboxFailurePayload,
  IUpdateDefaultMailboxSuccessPayload,
  IUpdateDefaultTeamFailurePayload,
  IUpdateDefaultTeamPayload,
  IUpdateDefaultTeamSuccessPayload,
  IUpdateDefaultTemplateFailurePayload,
  IUpdateDefaultTemplatePayload,
  IUpdateDefaultTemplateSuccessPayload,
  IVerifyLicenseFailurePayload,
  IVerifyLicensePayload,
} from "./interfaces";

export const LicenseSelectorsNames = {
  SET_COMPANY_NAME: { ...createEntitySelectorsNames("LICENSE.COMPANY_NAME") },
  SET_UKRAINE_SUPPORT_FOOTER: "LICENSE.UKRAINE_SUPPORT_FOOTER",
  SET_PARTNER_ID: "LICENSE.SET_PARTNER_ID",
  SET_SOURCE_FIRST_CLICK: "LICENSE.SET_SOURCE_FIRST_CLICK",
  SEND_FORWARDING_INSTRUCTIONS: "LICENSE.SEND_FORWARDING_INSTRUCTIONS",
};

export const LICENSE = {
  ...createEntityActionNames("LICENSE"),
  SET_COMPANY_NAME: createRequestTypes("LICENSE.COMPANY_NAME"),
  SET_UKRAINE_SUPPORT_FOOTER: createRequestTypes("LICENSE.UKRAINE_SUPPORT_FOOTER"),
  SET_POWERED_BY_FOOTER: createRequestTypes("LICENSE.POWERED_BY_FOOTER"),
  UPDATE_DEFAULT_TEAM: createRequestTypes("LICENSE.DEFAULT_TEAM"),
  UPDATE_DEFAULT_TEMPLATE: createRequestTypes("LICENSE.UPDATE_DEFAULT_TEMPLATE"),
  UPDATE_DEFAULT_MAILBOX: createRequestTypes("LICENSE.UPDATE_DEFAULT_MAILBOX"),
  SEND_FORWARDING_INSTRUCTIONS: createRequestTypes(LicenseSelectorsNames.SEND_FORWARDING_INSTRUCTIONS),
  SET_PARTNER_ID: createRequestTypes(LicenseSelectorsNames.SET_PARTNER_ID),
  UPDATE_TAG_REMINDER_TOGGLE: createRequestTypes("LICENSE.UPDATE_TAG_REMINDER_TOGGLE"),
  VERIFY: createRequestTypes("LICENSE.VERIFY"),
  RESEND_VERIFICATION: createRequestTypes("LICENSE.RESEND_VERIFICATION"),
  FETCH_LIVECHAT_PROPERTIES: createRequestTypes("LICENSE.FETCH_LIVECHAT_PROPERTIES"),
  SET_SOURCE_FIRST_CLICK: createRequestTypes(LicenseSelectorsNames.SET_SOURCE_FIRST_CLICK),
  CLEAR_GOOGLE_FORWARDING_LINK: "LICENSE.CLEAR_GOOGLE_FORWARDING_LINK",
  SET_LICENSE_FLAG: "LICENSE.SET_LICENSE_FLAG",
};

const setUkraineSupportFooter = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setUkraineSupportFooter: (payload: ISetUkraineFooterPayload) =>
    createAction(LICENSE.SET_UKRAINE_SUPPORT_FOOTER[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setUkraineSupportFooterSuccess: (payload: ISetUkraineFooterSuccessPayload) =>
    createAction(LICENSE.SET_UKRAINE_SUPPORT_FOOTER[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setUkraineSupportFooterFailure: (payload: ISetUkraineFooterFailurePayload) =>
    createAction(LICENSE.SET_UKRAINE_SUPPORT_FOOTER[RequestAction.FAILURE], payload),
};

const setPartnerId = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setPartnerId: (payload: ISetPartnerIdPayload) => createAction(LICENSE.SET_PARTNER_ID[RequestAction.REQUEST], payload),
};

const setSourceFirstClick = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setSourceFirstClick: (payload: ISetSourceFirstClick) =>
    createAction(LICENSE.SET_SOURCE_FIRST_CLICK[RequestAction.REQUEST], payload),
};

const setPoweredByFooter = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setPoweredByFooter: (payload: ISetPoweredByFooterPayload) =>
    createAction(LICENSE.SET_POWERED_BY_FOOTER[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setPoweredByFooterSuccess: (payload: ISetPoweredByFooterSuccessPayload) =>
    createAction(LICENSE.SET_POWERED_BY_FOOTER[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setPoweredByFooterFailure: (payload: ISetPoweredByFooterFailurePayload) =>
    createAction(LICENSE.SET_POWERED_BY_FOOTER[RequestAction.FAILURE], payload),
};

const setCompanyNameActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setCompanyName: (payload: ISetCompanyNamePayload) =>
    createAction(LICENSE.SET_COMPANY_NAME[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setCompanyNameSuccess: (payload: ISetCompanyNameSuccessPayload) =>
    createAction(LICENSE.SET_COMPANY_NAME[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setCompanyNameFailure: (payload: ISetCompanyNameFailurePayload) =>
    createAction(LICENSE.SET_COMPANY_NAME[RequestAction.FAILURE], payload),
};

const updateDefaultTeamActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultTeam: (payload: IUpdateDefaultTeamPayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_TEAM[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultTeamSuccess: (payload: IUpdateDefaultTeamSuccessPayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_TEAM[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultTeamFailure: (payload: IUpdateDefaultTeamFailurePayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_TEAM[RequestAction.FAILURE], payload),
};

const updateDefaultTemplateActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultTemplate: (payload: IUpdateDefaultTemplatePayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_TEMPLATE[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultTemplateSuccess: (payload: IUpdateDefaultTemplateSuccessPayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_TEMPLATE[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultTemplateFailure: (payload: IUpdateDefaultTemplateFailurePayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_TEMPLATE[RequestAction.FAILURE], payload),
};

const sendForwardingInstructionsActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  sendForwardingInstructions: (payload: ISendForwardingInstructionsPayload) =>
    createAction(LICENSE.SEND_FORWARDING_INSTRUCTIONS[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  sendForwardingInstructionsSuccess: (payload: ISendForwardingInstructionsSuccessPayload) =>
    createAction(LICENSE.SEND_FORWARDING_INSTRUCTIONS[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  sendForwardingInstructionsFailure: (payload: ISendForwardingInstructionsFailurePayload) =>
    createAction(LICENSE.SEND_FORWARDING_INSTRUCTIONS[RequestAction.FAILURE], payload),
};

const updateDefaultMailboxActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultMailbox: (payload: IUpdateDefaultMailboxPayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_MAILBOX[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultMailboxSuccess: (payload: IUpdateDefaultMailboxSuccessPayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_MAILBOX[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateDefaultMailboxFailure: (payload: IUpdateDefaultMailboxFailurePayload) =>
    createAction(LICENSE.UPDATE_DEFAULT_MAILBOX[RequestAction.FAILURE], payload),
};

const verifyActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  verify: (payload: IVerifyLicensePayload) => createAction(LICENSE.VERIFY[RequestAction.REQUEST], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  verifySuccess: () => createAction(LICENSE.VERIFY[RequestAction.SUCCESS]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  verifyFailure: (payload: IVerifyLicenseFailurePayload) =>
    createAction(LICENSE.VERIFY[RequestAction.FAILURE], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  resendVerification: () => createAction(LICENSE.RESEND_VERIFICATION[RequestAction.REQUEST]),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  resendVerificationSuccess: (payload: IResendVerificationSuccessPayload) =>
    createAction(LICENSE.RESEND_VERIFICATION[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  resendVerificationFailure: (payload: IResendVerificationFailurePayload) =>
    createAction(LICENSE.RESEND_VERIFICATION[RequestAction.FAILURE], payload),
};

const fetchPropertiesActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLivechatProperties: () => createAction(LICENSE.FETCH_LIVECHAT_PROPERTIES[RequestAction.REQUEST], {}),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLivechatPropertiesSuccess: (payload: IFetchLivechatPropertiesSuccessPayload) =>
    createAction(LICENSE.FETCH_LIVECHAT_PROPERTIES[RequestAction.SUCCESS], payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fetchLivechatPropertiesFailure: () => createAction(LICENSE.FETCH_LIVECHAT_PROPERTIES[RequestAction.FAILURE], {}),
};

export const LicenseActions = {
  ...createEntityActions<ILicense>(LICENSE),
  ...setUkraineSupportFooter,
  ...setCompanyNameActions,
  ...updateDefaultTeamActions,
  ...sendForwardingInstructionsActions,
  ...updateDefaultMailboxActions,
  ...verifyActions,
  ...fetchPropertiesActions,
  ...setPoweredByFooter,
  ...setPartnerId,
  ...updateDefaultTemplateActions,
  ...setSourceFirstClick,
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  clearGoogleForwardingLink: () => createAction(LICENSE.CLEAR_GOOGLE_FORWARDING_LINK),
  setLicenseFlag: (payload: ISetLicenseFlagPayload): IActionWithPayload<string, ISetLicenseFlagPayload> =>
    createAction(LICENSE.SET_LICENSE_FLAG, payload),
};

export type LicenseAction = ActionsUnion<typeof LicenseActions>;
